import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";

const Overview = ({ overview, links }) => {
    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            setMobile({ mobile: true });
        }
    }, []);
    return (
        <Container>
            <div className="overview-paragraph">
                {overview.map((res) => (
                    <p key={res} className={!mobile ? "text-left border-p-left" : "border-p-left"}>
                        {res}{" "}
                        {links ? (
                            <a className="text-left" href={links}>
                                Browse DETASAD's Marketplace
                            </a>
                        ) : (
                            ""
                        )}
                    </p>
                ))}
            </div>
        </Container>
    );
};

export default Overview;
